import { useEffect, useState } from 'react';
import client from '../../../utils/contentfulClient';
import BasicDetails from '../pages/BasicDetails/basic-details';
import Quiz3Review from '../pages/PDFReview/pdf-review';
import './QuizQuestions.css';
import AdditionalDetails from '../pages/AdditionalDetails/additional-details';

const QuizQuestions = () => {
  const [basicDetailsQuestion, setBasicDetailsQuestion] = useState([]);
  const [additionalDetailsQuestion, setAdditionalDetailsQuestion] = useState([]);
  const [currentPage, setCurrentPage] = useState('BasicDetails');

  const data = {
    currentPage: currentPage,
    pageList: [
      {
        pageName: 'BasicDetails',
        isQuiz: true,
        componentElm: (
          <BasicDetails
            backPage={() => goBack()}
            nextPage={() => goNext()}
            inputFields={basicDetailsQuestion}
            pageType={currentPage}
          ></BasicDetails>
        ),
      },
      {
        pageName: 'AdditionalDetails',
        isQuiz: true,
        componentElm: (
          <AdditionalDetails
            backPage={() => goBack()}
            nextPage={() => goNext()}
            inputFields={additionalDetailsQuestion}
            pageType={currentPage}
          ></AdditionalDetails>
        ),
      },
      {
        pageName: 'Quiz3Review',
        isQuiz: true,
        componentElm: (
          <Quiz3Review backPage={() => goBack()} nextPage={() => goNext()}></Quiz3Review>
        ),
      },
    ],
    quizData: [],
  };

  const goBack = () => {
    for (let i = 1; i < data.pageList.length; i++) {
      if (data.pageList[i]?.pageName == currentPage) {
        setCurrentPage(data.pageList[i - 1].pageName);
        window.scrollTo(0, 0);
      }
    }
  };

  const goNext = () => {
    for (let i = 0; i < data.pageList.length - 1; i++) {
      if (data.pageList[i]?.pageName == currentPage) {
        setCurrentPage(data.pageList[i + 1].pageName);
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    fetchContenful();
  }, []);

  const fetchContenful = async () => {
    const entryItems = await client.getEntries({ include: 10 });

    if (entryItems.items.length > 0) {
      const fields = entryItems.items.filter((item) => item.fields.id === 'HandbookQuiz');
      if (fields.length > 0) {
        setBasicDetailsQuestion(fields[0]?.fields?.questionGroups[0]);
        setAdditionalDetailsQuestion(fields[0]?.fields?.questionGroups[1]);
      }
    }
  };


  return (
    <>
      <div className="quiz-question-main-container">
        {currentPage != 'QuizIntro' ? (
          <div className="quiz-nav">
            <div className="quiz-nav-wrapper">
              <div
                className={
                  data.currentPage == 'BasicDetails'
                    ? 'nav-selected'
                    : ''
                }
              >
                <div>Step 1</div>
                <div>Basic Details</div>
              </div>
              <div
                className={
                  data.currentPage == 'AdditionalDetails'
                    ? 'nav-selected'
                    : ''
                }
              >
                <div>Step 2</div>
                <div>Additional Details</div>
              </div>
              <div className={data.currentPage == 'Quiz3Review' ? 'nav-selected' : ''}>
                <div>Step 3</div>
                <div>Review & Download</div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="quiz-body-container">
          {data.pageList.map((pageObj, i) => {
            return pageObj.pageName == currentPage ? (
              pageObj.pageName == 'AdditionalDetails' ? (
                pageObj.componentElm
              ) : (
                pageObj.componentElm
              )
            ) : (
              <></>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default QuizQuestions;
